import { render, staticRenderFns } from "./WorkspaceLayout.vue?vue&type=template&id=5af12508&"
import script from "./WorkspaceLayout.vue?vue&type=script&lang=ts&"
export * from "./WorkspaceLayout.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports